module.exports = __webpack_public_path__ + "img/intro_prod_tec_integral.d7ad25cc.jpg";